<template>
  <div>
    <AppTooltip>
      <template #activator="{ props }">
        <div
          v-bind="props"
          class="d-flex align-center clickable"
          @click="handleOpenFolderClick"
        >
          <app-material-icon name="folder" />

          <span v-if="document.parent">
            <span v-if="numberingEnabled && document.parent.numbering" class="mr-1">{{ `${document.parent.numbering}` }}</span>
            {{document.parent.name}}
          </span>
          <span v-else>
            {{$t("project.documents.DocumentLocationLink.rootFolder")}}
          </span>
        </div>
      </template>
      {{ $t('project.documents.DocumentLocationLink.tooltip') }}
    </AppTooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'

export default {
  name: 'DocumentLocationLink',
  components: { AppTooltip },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('documents', ['numberingEnabled']),
  },
  methods: {
    handleOpenFolderClick () {
      this.$emit('openInFolder', this.document)
    },
  },
}
</script>
